import { all, put, fork } from 'redux-saga/effects'

import restClient from '@/api/simple'
import addUploadFeature from '@/api/addUpload'
import authClient from '@/api/authClient'
import crudSaga from '@/state/sagas/crudSaga'

import createSagaWithRouting from '@/state/sagas/routes'
import { userCheck } from '@/state/actions/auth'
import wsSagas from './wsSagas'

const simpleRestClient = restClient()
const enhancedRest = addUploadFeature(simpleRestClient)
const restCall = (type, resource, params) =>
  new Promise(resolve => resolve(enhancedRest(type, resource, params)))

function* checkInitialAuth() {
  yield put(userCheck())
}

export default function(initialDispatch, routesMap) {
  return function* rootSaga() {
    yield all(
      [
        wsSagas,
        crudSaga(restCall, authClient),
        checkInitialAuth,
        createSagaWithRouting(initialDispatch, routesMap),
      ].map(fork),
    )
  }
}



// WEBPACK FOOTER //
// ./state/sagas/root.js